import Chat_ko from "locale/Chat/ko";
import Chat_en from "locale/Chat/en";
import PopUp_ko from "locale/PopUp/ko";
import PopUp_en from "locale/PopUp/en";
import Quick_ko from "locale/Quick/ko";
import Quick_en from "locale/Quick/en";
import ChatSide_ko from "locale/ChatSide/ko";
import ChatSide_en from "locale/ChatSide/en";
import VoiceChat_ko from "locale/VoiceChat/ko";
import VoiceChat_en from "locale/VoiceChat/en";
import Studio_ko from "locale/Studio/ko";
import Studio_en from "locale/Studio/en";
import AssetLibrary_ko from "locale/AssetLibrary/ko";
import AssetLibrary_en from "locale/AssetLibrary/en";
import Animation_ko from "locale/Animation/ko";
import Animation_en from "locale/Animation/en";
import SignIn_en from "locale/SignIn/en";
import SignIn_ko from "locale/SignIn/ko";
import SignUp_en from "locale/SignUp/en";
import SignUp_ko from "locale/SignUp/ko";
import BumperAD_ko from "locale/BumperAd/ko";
import BumperAD_en from "locale/BumperAd/en";
import SnsLogin_ko from "locale/SnsLogin/ko";
import SnsLogin_en from "locale/SnsLogin/en";
import AccountSettings_en from "./AccountSettings/en";
import AccountSettings_ko from "./AccountSettings/ko";
import {Common_en} from "./Common/en";
import {Common_ko} from "./Common/ko";

const locale = {
  ko: {
    ...Chat_ko,
    ...PopUp_ko,
    ...ChatSide_ko,
    ...Quick_ko,
    ...VoiceChat_ko,
    ...Studio_ko,
    ...AssetLibrary_ko,
    ...Animation_ko,
    ...SignIn_ko,
    ...SignUp_ko,
    ...BumperAD_ko,
    ...SnsLogin_ko,
    ...AccountSettings_ko,
    ...Common_ko,
  },
  en: {
    ...Chat_en,
    ...PopUp_en,
    ...ChatSide_en,
    ...Quick_en,
    ...VoiceChat_en,
    ...Studio_en,
    ...AssetLibrary_en,
    ...Animation_en,
    ...SignIn_en,
    ...SignUp_en,
    ...BumperAD_en,
    ...SnsLogin_en,
    ...AccountSettings_en,
    ...Common_en,
  },
};

export default locale;
